import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { IState } from "store/types";
import { userLogIn } from "../actions/user";
import Spinner from "components/spinner";
import { Button, Grid, Stack } from "@mui/material";
import styled from "@emotion/styled";
import AlignmentToolIcon from "./alignmentTool/images/landing.png";
import { get } from "lib/fetch";
import { setAuthenticating } from "actions/authenticatingUser";
import { performAuth } from "lib/authentication";

const PageTitle = styled.h2`
  margin-top: 0.5rem;
  margin-bottom: 0rem;
  letter-spacing: -1px;
  align-items: center;
  text-align: center;
`;

const PageDescription = styled.p`
  margin-top: 1rem;
  margin-bottom: 1rem;
  align-items: center;
  text-align: center;
`;

const LoginButton = styled(Button)`
  margin-top: 1rem;
`;

export const Login = () => {
  const authenticating = useSelector((state: IState) => state.authenticatingUser);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");
  const dispatch = useDispatch();

  const doLogIn = useCallback(async () => {
    try {
      setLoginErrorMessage("");
      dispatch(setAuthenticating(true));
      const data = await performAuth();
      if (data != null) {
        const accessData = await get("/v1/userinfo");
        const responsePromise: any = dispatch(userLogIn({ ...data, valid: accessData.access }));
        await responsePromise;
      }
    } catch (e: any) {
      setLoginErrorMessage(e.message);
    } finally {
      dispatch(setAuthenticating(false));
    }
  }, [dispatch]);

  // Log in immediately
  useEffect(() => {
    doLogIn();
  }, [doLogIn]);

  return (
    <Stack>
      <img
        src={AlignmentToolIcon}
        style={{ alignSelf: "center", paddingTop: "100px", paddingBottom: "20px" }}
        width="252"
        height="168"
        alt="LMSMorph icon"
      />
      {!authenticating && (
        <>
          <PageTitle>LMSMorph</PageTitle>
          <PageDescription>To use LMSMorph you will need to login.</PageDescription>
          <Grid
            tabIndex={-1}
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <LoginButton variant="contained" id="login" onClick={() => doLogIn()}>
              Login
            </LoginButton>
          </Grid>
          {loginErrorMessage && <div style={{ color: "red", textAlign: "center" }}>{loginErrorMessage}</div>}
        </>
      )}
      {authenticating && <Spinner loading={authenticating} />}
    </Stack>
  );
};
